(function (Drupal, once) {
  Drupal.behaviors.youtubeIframeFix = {
    attach(context) {
      // Select all YouTube iframes (including embeds and short URLs)
      once(
        "youtube-iframe-fix",
        'iframe[src*="youtube.com"], iframe[src*="youtu.be"]',
        context,
      ).forEach((iframe) => {
        // Ensure frameborder attribute
        iframe.setAttribute("frameborder", "0");

        // Ensure full allow permissions required by YouTube
        iframe.setAttribute(
          "allow",
          "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
        );

        // Enforce strict referrer policy
        iframe.setAttribute(
          "referrerpolicy",
          "strict-origin-when-cross-origin",
        );

        // Ensure fullscreen support
        iframe.setAttribute("allowfullscreen", "allowfullscreen");
      });
    },
  };
})(Drupal, once);
